/**
 * Trace campaign entity data flow in the browser DevTools.
 *
 * Enable once per origin:
 *   localStorage.setItem('mythkit_debug_campaign_data', '1')
 * Disable:
 *   localStorage.removeItem('mythkit_debug_campaign_data')
 */
export const CAMPAIGN_DATA_DEBUG_STORAGE_KEY = 'mythkit_debug_campaign_data';

export function isCampaignDataDebugEnabled(): boolean {
  if (typeof window === 'undefined') return false;
  try {
    return window.localStorage.getItem(CAMPAIGN_DATA_DEBUG_STORAGE_KEY) === '1';
  } catch {
    return false;
  }
}

function safePreview(value: unknown, maxLen = 2000): unknown {
  if (value === null || value === undefined) return value;
  if (typeof value === 'string') {
    return value.length > maxLen ? `${value.slice(0, maxLen)}… (${value.length} chars)` : value;
  }
  try {
    const s = JSON.stringify(value);
    return s.length > maxLen ? `${s.slice(0, maxLen)}… (${s.length} chars)` : value;
  } catch {
    return String(value);
  }
}

/** Prefix with [Mythkit campaign-data] so you can filter the console. */
export function logCampaignData(scope: string, message: string, payload?: unknown): void {
  if (!isCampaignDataDebugEnabled()) return;
  const label = `[Mythkit campaign-data] ${scope}: ${message}`;
  if (payload !== undefined) {
    console.info(label, safePreview(payload));
  } else {
    console.info(label);
  }
}

export function shouldLogCampaignApiUrl(url: string): boolean {
  if (!isCampaignDataDebugEnabled()) return false;
  return /\/api\/campaigns\/\d+\/(shops|locations|npcs)(\/|$|\?)/.test(url);
}
